
<template>
    <div class="card">
      <div class="card-header pb-0">
        <h6>Sewa Pajak</h6>
        <div class="row">
            <div class="col-md-3">
              <label for="example-text-input" class="form-control-label">Quick Search</label>
              <input
                type="text"
                v-model="searchQuery"
                placeholder="Search..."
                class="form-control mb-3"
                style="max-width: 250px; "
              />
            </div>
            <div class="col-md-3">
                <label for="example-text-input" class="form-control-label">Date From</label>
                <input type="date" id="input_date" class="form-control" v-model="search.datefrom" >
            </div>
            <div class="col-md-3">
                <label for="example-text-input" class="form-control-label">Date To</label>
                <input type="date" id="input_date" class="form-control" v-model="search.dateto" >
            </div>
            <div class="col-md-2">
                <label for="example-text-input" class="form-control-label" style="width: 100%;">&nbsp;</label>
                <button class="btn btn-success " @click="getSewaPajak" style="float: right;" id="btn_search">Search</button>
            </div>
        </div>
      </div>
      <hr />
      <div class="card-body px-0 pt-0 pb-2">
        <div class="table-responsive p-0">
          <table class="table align-items-center mb-0">
            <thead>
              <tr>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                  Block
                </th>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                  Amount (RM)
                </th>
                <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                  Remark
                </th>
                <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                  Date
                </th>
                <th class="text-secondary opacity-7"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(sewaPajak,index) in paginatedSewaPajak" :key="index">
                <td>
                  <div class="d-flex px-2 py-1">
                    <div class="d-flex flex-column justify-content-center">
                      <h6 class="mb-0 text-sm">{{ (currentPage-1)*10 + index +1 }}. {{ sewaPajak.blockid }} - {{ sewaPajak.blockname }} <br />{{ sewaPajak.remark }}</h6>
                    </div>
                  </div>
                </td>
                <td>
                  <h6 class="text-xs font-weight-bold mb-0">{{ sewaPajak.amount }}</h6>
                </td>
                <td>
                  <h6 class="text-xs font-weight-bold mb-0">{{ sewaPajak.description }}</h6>
                </td>
                <td>
                  <h6 class="text-xs font-weight-bold mb-0">{{ sewaPajak.paymentdate }}</h6>
                </td>
                <td class="align-middle">
                  <RouterLink :to="{path : '/editBlock/'+ sewaPajak.blockid}"
                    href="javascript:;"
                    class="text-secondary font-weight-bold text-xs"
                    data-toggle="tooltip"
                    data-original-title="Edit Block"
                    >Remove
                  </RouterLink>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- Pagination Controls -->
          <hr />
          <div class="pagination-container">
            <div>
              <button @click="prevPage" :disabled="currentPage === 1" class="btn btn-info">Previous</button>
              <span class="form-control-label" style="padding:10px"> Page {{ currentPage }} of {{ totalPages }} </span>
              <button @click="nextPage" :disabled="currentPage === totalPages" class="btn btn-info">Next</button>
            </div>
            
            <span class="form-control-label total-rows">Total {{ totalRows }} entries </span>
          </div>
        </div>
      </div>
    </div>
  </template>

  
<script>
import axios from 'axios';

export default {
  name:'blockSelect',
  data(){
    return {
      totalRows:0,
      currentPage: 0,
      searchQuery:'',
      perPage: 10,
      sewaPajak: [],
      search:{
        dateto: new Date().toISOString().slice(0,10),
        datefrom: new Date(this.currentDate()).toISOString().slice(0,10),
      }
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.sewaPajak.length / this.perPage);
    },
    paginatedSewaPajak() {
      const start = (this.currentPage - 1) * this.perPage;
      let query = this.searchQuery.toLowerCase();

      // Filter customers by checking all properties in each row
      let filtered = this.sewaPajak.filter(item => {
        return Object.values(item).some(value =>
          String(value).toLowerCase().includes(query)
        );
      });
      return filtered.slice(start, start + this.perPage);
    }
  },
  mounted(){
    this.getSewaPajak();
  },
  methods: {
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    currentDate() {
      const firstDayMonth = new Date();
      const date = `${firstDayMonth.getMonth()+1}/02/${firstDayMonth.getFullYear()}`;
      return date;
    },
    getSewaPajak(){
      axios.get('block/listSewaPajak/' + this.search.datefrom + '/' + this.search.dateto)
            .then(res => {
              this.currentPage = 1;
              this.totalRows = res.data.sewaPajak.length;
              // console.log(res.data.sewaPajak);
              this.sewaPajak = res.data.sewaPajak;
            }).catch(function (error){
                
              console.log('Error',error.message);
            });
    }
  },
}
</script>
  